import { Controller } from "stimulus"
import { fetchJSON } from "../lib/fetch_json"

export default class extends Controller {
  static targets = ["field", "saveIndicator", "bannerInput", "logoInput"]
  static values = { saveUrl: String }

  connect() {
    this._saveTimeout = null
    this._dirty = false
  }

  disconnect() {
    clearTimeout(this._saveTimeout)
  }

  onFieldChange() {
    this._dirty = true
    this.showSaveState("dirty")
    clearTimeout(this._saveTimeout)
    this._saveTimeout = setTimeout(() => this.triggerSave(), 800)
  }

  onBannerChange(event) {
    // Image uploads will be handled in Phase 2 polish
    // For now, just show a preview
    const file = event.target.files[0]
    if (!file) return
    this.showSaveState("dirty")
  }

  onLogoChange(event) {
    const file = event.target.files[0]
    if (!file) return
    this.showSaveState("dirty")
  }

  async triggerSave() {
    if (!this._dirty) return

    this.showSaveState("saving")
    const payload = {}
    this.fieldTargets.forEach(field => {
      const name = field.dataset.fieldName
      if (name) payload[name] = field.value
    })

    try {
      const data = await fetchJSON(this.saveUrlValue, {
        method: "PATCH",
        body: { opportunity: payload }
      })
      if (data.errors) {
        this.showSaveState("error")
      } else {
        this._dirty = false
        this.showSaveState("saved")
        document.dispatchEvent(new CustomEvent("opp-editor:saved", {
          detail: { section: "media", completion: data.completion }
        }))
      }
    } catch (e) {
      this.showSaveState("error")
    }
  }

  showSaveState(state) {
    if (!this.hasSaveIndicatorTarget) return
    const el = this.saveIndicatorTarget
    el.classList.remove("d-none")
    switch (state) {
      case "dirty":
        el.innerHTML = '<span class="text-muted"><i class="fas fa-pencil-alt fa-sm me-1"></i>Unsaved</span>'
        break
      case "saving":
        el.innerHTML = '<span class="text-info"><i class="fas fa-spinner fa-spin fa-sm me-1"></i>Saving...</span>'
        break
      case "saved":
        el.innerHTML = '<span class="text-success"><i class="fas fa-check fa-sm me-1"></i>Saved</span>'
        setTimeout(() => { if (!this._dirty) el.classList.add("d-none") }, 3000)
        break
      case "error":
        el.innerHTML = '<span class="text-danger"><i class="fas fa-exclamation-circle fa-sm me-1"></i>Error</span>'
        break
    }
  }
}
